<script lang="ts">
  /**
   * インラインの木を描く（lesson-format.md §5.2）。文字列はすべて補間で出し、{@html} は使わない。
   * リンクは lessonLinkTarget（問題では problemLinkTarget）で確かめ直し、通らなければ文字だけを描く（§5.4）。
   */
  import InlineNodes from './InlineNodes.svelte';
  import { recordLessonIssue } from '../../lib/telemetry/attributes';
  import { getLessonId, getLinkTargetCheck } from './lesson-context';
  import type { Inline } from './types';

  interface Props {
    nodes: readonly Inline[];
  }

  let { nodes }: Props = $props();
  const lessonId = getLessonId();
  /** 既定は lessonLinkTarget。問題の画面は problemLinkTarget に差し替える */
  const linkTarget = getLinkTargetCheck();

  /** 許可しないリンクは文字だけを描き、テレメトリに送る（§5.4） */
  function checkLink(href: string) {
    const target = linkTarget(href);
    if (target === null) recordLessonIssue(lessonId, 'link_rejected');
    return target;
  }
</script>

{#each nodes as node, i (i)}
  {#if node.type === 'text'}{node.value}{:else if node.type === 'inlineCode'}<code
      >{node.value}</code
    >{:else if node.type === 'emphasis'}<em><InlineNodes nodes={node.children} /></em
    >{:else if node.type === 'strong'}<strong><InlineNodes nodes={node.children} /></strong
    >{:else if node.type === 'break'}<br />{:else if node.type === 'link'}{@const target =
      checkLink(node.href)}{#if target === null}<InlineNodes
        nodes={node.children}
      />{:else if !target.external}<a href={target.href}><InlineNodes nodes={node.children} /></a
      >{:else}<a class="external" href={target.href} target="_blank" rel="noopener noreferrer"
        ><InlineNodes nodes={node.children} /><span class="ext-mark" aria-hidden="true">↗</span
        ><span class="visually-hidden">（外部サイト、新しいタブ）</span></a
      >{/if}{/if}
{/each}

<style>
  .ext-mark {
    margin-left: 0.15em;
    font-size: 0.85em;
  }
</style>
